import Player from 'widget/player-widget/components/player/player';
import SocialShare from 'widget/player-widget/components/social-share/social-share';
import Dropdown from 'widget/player-widget/components/dropdown/dropdown';

import updateCSS from 'widget/player-widget/utils/update-css';
import * as dealInfoHelpers from 'widget/player-widget/utils/deal-info-helpers';
import * as queryString from 'widget/player-widget/utils/query-string';
import getUrlToVideo from 'widget/player-widget/utils/get-url-to-video';

import defaultSettings from 'widget/player-widget/constants/default-settings';
import channelLayoutValues from 'widget/player-widget/constants/default-settings/channel-layout-values';
import channelVideoListValues from 'widget/player-widget/constants/default-settings/channel-video-list-values';
import infoPositionValues from 'widget/player-widget/constants/default-settings/info-position-values';
import layoutStyleValues from 'widget/player-widget/constants/default-settings/layout-style-values';
import mainItemTypeValues from 'widget/player-widget/constants/default-settings/main-item-type-values';
import showInfoValues from 'widget/player-widget/constants/default-settings/show-info-values';
import titlePositionValues from 'widget/player-widget/constants/default-settings/title-position-values';
import posterPositionValues from 'widget/player-widget/constants/poster-position';
import showMediaTypeValues from 'widget/player-widget/constants/default-settings/show-media-type-values';

import { OVERLAY_ACTION_TYPES } from 'widget/player-widget/components/player/overlay-actions/overlay-action-utils';


export {
  Player,
  SocialShare,
  Dropdown,

  updateCSS,
  dealInfoHelpers,
  queryString,
  getUrlToVideo,

  defaultSettings,
  channelLayoutValues,
  channelVideoListValues,
  infoPositionValues,
  layoutStyleValues,
  mainItemTypeValues,
  showInfoValues,
  titlePositionValues,
  posterPositionValues,
  showMediaTypeValues,

  OVERLAY_ACTION_TYPES,
};

export default Player;



// WEBPACK FOOTER //
// ./src/widget/player-widget/index.js